import styled from 'styled-components';
import { colors } from '../colors';

const TitleHeaderRight = styled.div`
	display: flex;
	align-items: center;
	color: ${colors.BlueBase};
	.btn-default {
		margin-left: 28px;
	}
`;

export default TitleHeaderRight;
